/*
 * Availability results
 *   - Reads query from data-* on .js-availability-results
 *   - Fires AJAX to ppd_mews_availability
 *   - Renders room cards or an error message
 */

function ajaxUrl() {
    return (window.ajax_var && window.ajax_var.ppd_ajax_url) || '/wp-admin/admin-ajax.php';
}
function nonce() {
    return (window.ajax_var && window.ajax_var.nonce) || '';
}

function formatMoney(value, currency) {
    try {
        return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: currency || 'AUD',
            maximumFractionDigits: 0,
        }).format(value);
    } catch (_e) {
        return (currency || 'AUD') + ' ' + Math.round(value);
    }
}

function renderRooms(container, rooms) {
    if (!rooms.length) {
        container.innerHTML = `<div class="availability__empty"><p>${emptyMessage(container)}</p></div>`;
        return;
    }

    // Render with --i index so the CSS @keyframes animation can stagger
    // the fade-in (animation-delay: calc(var(--i) * 80ms)).
    const html = rooms.map((r, i) => `
        <li class="availability-card" style="--i: ${i};">
            <div class="availability-card__media">${
                r.image
                    ? `<img src="${r.image}" alt="${escapeAttr(r.name)}">`
                    : ''
            }</div>
            <div class="availability-card__body">
                <h3 class="availability-card__title">${escapeHtml(r.name || 'Room')}</h3>
                ${r.description ? `<p class="availability-card__description">${escapeHtml(r.description)}</p>` : ''}
                <div class="availability-card__footer">
                    <div class="availability-card__price">
                        <span class="availability-card__price-label">From</span>
                        <span class="availability-card__price-value">${r.from_price != null ? formatMoney(r.from_price, r.currency) : '—'}</span>
                        <span class="availability-card__price-unit">${escapeHtml(r.price_unit || 'per room/nightly')}</span>
                    </div>
                    <a class="availability-card__cta btn" href="${r.handoff_url}" target="_blank" rel="noopener">
                        <span>Book now</span>
                    </a>
                </div>
            </div>
        </li>
    `).join('');

    container.innerHTML = `<ul class="availability-cards">${html}</ul>`;
}

function renderError(container, message) {
    container.innerHTML = `<div class="availability__error"><p>${escapeHtml(message || 'Could not fetch availability.')}</p></div>`;
}

/**
 * Empty-state copy. When the user's stay-length doesn't fit the booked
 * stay type, nudge them toward the other one with a one-click swap link;
 * fall back to a generic message otherwise.
 *
 * Boundaries:
 *   STAY  → 1–28 nights
 *   LIVE  → 29+ nights
 */
function emptyMessage(container) {
    const stayType = (container.dataset.stayType || '').toLowerCase();
    const arrive   = container.dataset.arrive || '';
    const depart   = container.dataset.depart || '';

    let nights = 0;
    if (arrive && depart) {
        const a = new Date(arrive + 'T00:00:00');
        const d = new Date(depart + 'T00:00:00');
        if (!isNaN(a.getTime()) && !isNaN(d.getTime())) {
            nights = Math.max(0, Math.round((d - a) / 86400000));
        }
    }

    const swapTo  = stayType === 'stay' ? 'live' : 'stay';
    const swapUrl = swapStayTypeUrl(swapTo);
    const swapLbl = swapTo.toUpperCase();

    if (stayType === 'stay' && nights > 28) {
        return `Looks like you're planning a longer stay! STAY is for under 28 nights. ` +
               `Pop over to <a href="${swapUrl}">${swapLbl}</a> for anything 29 nights and over.`;
    }
    if (stayType === 'live' && nights > 0 && nights < 29) {
        return `Looks like you're after a shorter stay! LIVE is for 29 nights and over. ` +
               `Pop over to <a href="${swapUrl}">${swapLbl}</a> for anything under 28 nights.`;
    }

    return 'No rooms available for the selected dates.';
}

/**
 * Build the current-page URL with `stay_type` swapped — all other query
 * params (city, arrive, depart, etc.) are preserved so the user lands on
 * the equivalent search in the other stay type.
 */
function swapStayTypeUrl(newStayType) {
    const url = new URL(window.location.href);
    url.searchParams.set('stay_type', newStayType);
    return url.toString();
}

function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[c]));
}
function escapeAttr(s) { return escapeHtml(s); }

export function initAvailability() {
    const container = document.querySelector('.js-availability-results');
    if (!container) return;

    const body = new FormData();
    body.append('action',    'ppd_mews_availability');
    body.append('nonce',     nonce());
    body.append('stay_type', container.dataset.stayType || '');
    body.append('city',      container.dataset.city || '');
    body.append('arrive',    container.dataset.arrive || '');
    body.append('depart',    container.dataset.depart || '');
    body.append('adults',    container.dataset.adults || '1');
    if (container.dataset.roomId) {
        body.append('room_id', container.dataset.roomId);
    }

    fetch(ajaxUrl(), { method: 'POST', credentials: 'same-origin', body })
        .then(r => r.json())
        .then(json => {
            if (!json || !json.success) {
                renderError(container, json && json.data && json.data.message);
                return;
            }
            renderRooms(container, json.data.rooms || []);
        })
        .catch(err => renderError(container, err.message));
}
